import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export let ShowOneSectorThunk = createAsyncThunk(
	"SectorSolutions/ShowOneSectorThunk",
	async (arg, ThunkApi) => {
		let { rejectWithValue } = ThunkApi;
		try {
			const url = `https://api.raj.com.sa/api/public/sector_solutions/${arg}`;
			const res = await axios.get(url, {
				headers: {
					Locale: localStorage.getItem("language") || navigator?.languages?.[1],
				},
			});

			return res.data;
		} catch (error) {
			return rejectWithValue(error.response.data.data);
		}
	}
);
